import { combineReducers } from "redux"

import workbooksReducers from "./../routes/workbooks/reducers"

const reducers = combineReducers(Object.assign({}, workbooksReducers));

export default reducers;